import { FC, useLayoutEffect, useRef, useState } from "react";
import { cn } from "@/libs/utils";
import Download from "src/components/legals/Download";
import { useTrans } from "src/utils/useTrans";
import A from "src/components/A";

type Props = {
  className?: string;
  title?: string;
  /** PDF 배포본. 아직 생성 파이프라인이 없어 없을 수 있다 (docs/legal-docs-policy.md §7) */
  href?: string;
};

const LeftSection: FC<Props> = ({ title = "", className = "", href }) => {
  const { t } = useTrans(["gnb"]);
  const ref = useRef<any>(null);
  const [margin, setMargin] = useState("");

  useLayoutEffect(() => {
    if (ref.current?.getBoundingClientRect().height > 36) {
      setMargin("-mt-9");
    } else {
      setMargin("");
    }
  }, [href]);

  return (
    <div className={cn(className, "flex flex-col")}>
      <p
        ref={ref}
        className={`text-1.5xl block font-700 leading-tight md:text-2xl lg:text-3xl ${margin}`}
      >
        {t(`${title}`)}
      </p>
      <span className={"mt-2.5 h-px w-full bg-[#222222]"} />
      {!!href && (
        <A className="max-w-[270px] pt-10" href={href}>
          <Download />
        </A>
      )}
    </div>
  );
};

export default LeftSection;
